import { Link } from "gatsby"
import React from "react"
import styled from "styled-components"
import LogoImage from "./LogoImage"
import { SimpleTopBarButton } from "./TopBarButton"

const LogoIconBar = styled.span`
  border-top: 1px solid ${props => props.theme.color.text};
  width: 10px;
  position: absolute;
  left: 50%;
  margin-left: -5px;
  transition: ${props => props.theme.transition.long};
`

const LogoIcon = styled.i`
  position: relative;
  float: left;
  width: 36px;
  height: 36px;
  margin-right: 5px;
  border-radius: 50%;
  border: 1px solid ${props => props.theme.color.text};
  transition: ${props => props.theme.transition.long};
  & ${LogoIconBar}:nth-child(1) {
    top: 14px;
  }
  & ${LogoIconBar}:nth-child(2) {
    top: 17px;
  }
  & ${LogoIconBar}:nth-child(3) {
    top: 20px;
  }
`

const LogoButton = styled(SimpleTopBarButton)`
  padding-left: 5px;
  &:hover {
    ${LogoIcon} {
      &,
      ${LogoIconBar} {
        border-color: ${props => props.theme.color.highlight};
      }
    }
  }
`

const handleIconClick = onIconClick => {
  return evt => {
    evt.preventDefault()
    evt.stopPropagation()
    if (typeof onIconClick === "function") {
      onIconClick(evt)
    }
  }
}

const Logo = ({ onIconClick, ...rest }) => {
  return (
    <LogoButton as={Link} {...rest}>
      <LogoIcon onClick={handleIconClick(onIconClick)}>
        <LogoIconBar />
        <LogoIconBar />
        <LogoIconBar />
      </LogoIcon>
      <LogoImage width={100} />
    </LogoButton>
  )
}

export default Logo
